/**
 * Convert price to lines
 * @param input input
 */
export function convertPriceToLines(input) {
    const priceLines = [];
    Object.entries(input).forEach(([key, value]) => {
        priceLines.push({
            id: `${Math.random()}`.substring(2),
            name: key,
            // the matrix stores prices in cents, so we need to divide by 100
            price: value / 100,
        });
    });
    return priceLines;
}

/**
 * Convert lines to price
 * @param newLines newLines
 */
export function convertLinesToPrice(newLines) {
    const priceValue = {};
    for (let i = 0; i < newLines.length; i++) {
        priceValue[newLines[i].name] = Math.floor(newLines[i].price * 100);
    }
    return priceValue;
}
